import { render } from "./QuestionnaireView.vue?vue&type=template&id=07549fec&scoped=true"
import script from "./QuestionnaireView.vue?vue&type=script&lang=js"
export * from "./QuestionnaireView.vue?vue&type=script&lang=js"

import "./QuestionnaireView.vue?vue&type=style&index=0&id=07549fec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07549fec"]])

export default __exports__